module.exports = __webpack_public_path__ + "static/media/CTLI_2-178w.f718e35a.webp";